// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__20EYE","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1RoEz"};